import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

export const financeSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getFinanceListing: builder.query({
      query: (query) => ({
        url: `orders-listing${query}`,
        method: "GET",
      }),
      providesTags: [tagsTypes.GET_FINANCE_LISTING],
    }),

    getTransactionsListing: builder.query({
      query: () => ({
        url: `finance-transactions`,
        method: "GET",
      }),
      providesTags: [tagsTypes.GET_TRANSACTIONS_LISTING],
    }),

    postMarkAsRedeem: builder.mutation({
      query: (data) => ({
        url: "orders/mark-as-redeem",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        tagsTypes.GET_FINANCE_LISTING,
        tagsTypes?.GET_DASHBOARD_CONTENT,
      ],
    }),
  }),
});

export const {
  useGetFinanceListingQuery,
  useGetTransactionsListingQuery,
  usePostMarkAsRedeemMutation,
} = financeSlice;
